import { getDeviceCommandTimestamp } from '../../../common/device-last-command.model';
import { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { I4BCellType, I4BColumnConfiguration } from '../configurations';
import { DataLibrary, I4bCellConcept } from '../enums';
import { I4BBasicColumnHeader } from '../headers';
import { HeaderType, I4BColumnHeader } from '../models';
import { BasicColumnOptions, I4BColumnOptions } from '../options';
import { I4BColumn } from './i4b-column';

export class LastCommandDateTimeColumn implements I4BColumn<I4BBasicColumnHeader, I4BColumnConfiguration, I4BColumnOptions> {
  columnId = 'c024bd53-9fd3-12bc-9da8-1123a40210d0-last-command-date-time';
  className = LastCommandDateTimeColumn;

  dataLibs: DataLibrary[] = [DataLibrary.DEVICES];

  header: I4BBasicColumnHeader = new I4BBasicColumnHeader({ type: HeaderType.BASIC, displayName: 'LAST COMMAND DATE' });
  configuration: I4BColumnConfiguration = {
    isLink: false,
    position: '',
    id: 'lastCommand',
    translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.LAST_COMMAND_DATE',
    sortProperty: '',
    concept: I4bCellConcept.DEVICES,
    isDefault: false,
    isConfigurable: true,
    width: 190,
    cell: {
      type: I4BCellType.LAST_COMMAND_DATE_CELL
    }
  };
  options: I4BColumnOptions = new BasicColumnOptions({ sortable: true });

  constructor(customHeader?: Partial<I4BColumnHeader>, customConfig?: Partial<I4BColumnConfiguration>, customOptions?: Partial<I4BColumnOptions>) {
    if (customHeader) {
      this.header = new I4BBasicColumnHeader({
        ...this.header,
        ...customHeader
      });
    }
    if (customConfig) {
      this.configuration = {
        ...this.configuration,
        cell: { ...this.configuration.cell, ...customConfig.cell }
      };
    }
    if (customOptions) {
      this.options = { ...this.options, ...customOptions };
    }
    this.configuration.cell.valueGetter = this.valueGetter.bind(this);
  }

  valueGetter(params: ValueGetterParams) {
    const lastCommand = get(params, 'data.lastCommand');
    return getDeviceCommandTimestamp(lastCommand);
  }
}
